import { NgModule } from '@angular/core';
import { NgPassComponent } from '../components/tools/ng-pass/ng-pass.component';
import { NgPassConfirmComponent } from '../components/tools/ng-pass-confirm/ng-pass-confirm.component';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    NgPassComponent,
    NgPassConfirmComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PasswordModule,
    DividerModule,
    TranslateModule
  ],
  exports: [
    NgPassComponent,
    NgPassConfirmComponent,
    PasswordModule,
    DividerModule
  ]
})
export class AuthSharedModule { }
